export default __webpack_public_path__ + "static/media/division-4.0b0bb13a.png";